import { StoreType } from "@reducers/types";
import { GpfsState } from "@reducers/types/HRM/gpfs-state";

export const getGpfsState = (state: StoreType): GpfsState => state.hrm.gpfs;
